module.exports = __webpack_public_path__ + "fonts/F37Moon-ExtraBold.6a01a7e.otf";